import { combineReducers } from "redux";
import current from "./settingCurrentReducer";
import mother from "./settingMotherReducer";

export default combineReducers({
  current,
  mother
});
